import React from 'react';

import loadable from '@common/react/loadable/loadableSettings';

import { Feature } from '@commonTuna/react/objects/CompanyFeature';

import CompanyFeatureAccess from '@app/components/UI/CompanyFeatureAccess/CompanyFeatureAccess';

const PhoneCallPopupModal = loadable(
	() => import(/* webpackChunkName: "PhoneCallPopupModal" */'@app/components/UI/PhoneCallPopupModal/PhoneCallPopupModal'),
	{ fallback: <></> },
);

const PhoneCallModal: React.FC = () => {
	return (
		<CompanyFeatureAccess feature={Feature.PhoneCall}>
			<PhoneCallPopupModal />
		</CompanyFeatureAccess>
	);
};

export default PhoneCallModal;
